import { NgModule } from '@angular/core';
import { JsonDynamicFieldComponent } from './json-dynamic-field.component';

@NgModule({
	declarations: [],
	imports: [JsonDynamicFieldComponent],
	exports: [JsonDynamicFieldComponent],
})
export class JsonDynamicFieldModule {}
